import { h } from '@atomify/jsx';

interface CheckboxProps {
    validationTypes?: string | null;
    validationRegex?: string | null;
    validationErrorMessage?: string | null;
    requiredErrorMessage?: string | null;
    value?: any;
    horizontal?: boolean;
    classes?: string;
    disabled?: boolean;
    name: string;
    id: string;
    required?: boolean;
    checked?: boolean;
    hook?: string;
    bpdInputHook?: string;
    labelHook?: string;
    attr?: string[];
    label: string | Text;
    error?: string;
    srOnly?: boolean;
    displayName?: string | null;
    hideError?: boolean;
}

export const CheckboxElement = ({
    validationTypes,
    validationRegex,
    validationErrorMessage,
    requiredErrorMessage,
    value,
    horizontal,
    classes,
    disabled,
    name,
    id,
    required,
    checked,
    hook,
    bpdInputHook,
    labelHook,
    attr,
    label,
    error,
    srOnly,
    displayName,
    hideError = false,
}: CheckboxProps) => {
    const inputClasses = {
        ['c-checkbox']: true,
        ['form__item']: true,
        'checkbox--horizontal': horizontal,
        ['form__item--disabled']: disabled,
    };
    return (
        <bpd-input
            validation-types={validationTypes}
            validation-regex={validationRegex}
            validation-error-message={validationErrorMessage}
            required-error-message={requiredErrorMessage}
            bindValue={value}
            class={classes}
            displayName={displayName}
            {...{ [`js-hook-${bpdInputHook}`]: bpdInputHook }}>
            <div class={inputClasses}>
                <div class="checkbox__wrapper">
                    <input
                        class="checkbox__input u-sr-only"
                        type="checkbox"
                        name={name}
                        id={id}
                        required={required}
                        disabled={disabled}
                        checked={checked}
                        value={value}
                        {...{ [`js-hook-${hook ? hook : ''}`]: !!hook, ...attr }}
                    />

                    <label class="checkbox__label" for={id}>
                        <span
                            class={{ 'u-sr-only': srOnly }}
                            {...{ [`js-hook-${labelHook}`]: labelHook }}>
                            {label}
                        </span>
                        <span class="checkbox__hover-helper"></span>
                        <span class="checkbox__focus-helper"></span>
                    </label>
                </div>
                {!hideError && (
                    <div class="form__item-error" role="alert">
                        {error}
                    </div>
                )}
            </div>
        </bpd-input>
    );
};
